import { App } from "core.app";
import { startLocalConsumers } from "../Consumers";
import { overrideContainer } from "../Container";

export function getApp() {
  overrideContainer();
  startLocalConsumers();

  return App;
}

export default getApp;
